import type { SVGProps } from "react";

const SvgFlagBE = (props: SVGProps<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        width="18"
        height="18"
        viewBox="0 0 4.76 4.76"
        {...props}
    >
        <defs>
            <circle id="a" cx="9" cy="9" r="9" />
        </defs>
        <g fillRule="evenodd" transform="matrix(0 -.26458 .26458 0 0 4.76)">
            <mask id="b" fill="#fff">
                <use width="100%" height="100%" xlinkHref="#a" />
            </mask>
            <use width="100%" height="100%" fill="#fec439" xlinkHref="#a" />
            <path d="M-2 0h20v6H-2z" mask="url(#b)" />
            <path fill="#d0021b" d="M-2 12h20v6H-2z" mask="url(#b)" />
        </g>
    </svg>
);

export default SvgFlagBE;
